import { Link } from "react-router-dom";
import { StarFill } from "react-bootstrap-icons";
import PageHero from "../../common/ui/PageHero";
import { LoadingBlock, EmptyBlock } from "../../common/ui/StateBlock";
import { formatPrice, carTitle, formatMileage } from "../../common/format";
import useWatchlist from "../../common/useWatchlist";
import { thumbStyle } from "./myShared";
import { t } from "./auctionI18n";
import "./Auction.css";
import "../../common/ui/ui.css";

const AuctionWatchlist = () => {
    const watch = useWatchlist();

    if (!watch.ready) return <div className="container auction-narrow"><LoadingBlock label={t("იტვირთება...", "Loading...", "Загрузка...", "Բեռնվում է...")} /></div>;

    const rows = watch.rows || [];

    return (
        <>
            <PageHero eyebrow="Carexpress" title={t("ჩემი რჩეულები", "My favorites", "Моё избранное", "Իմ ընտրանին")} subtitle={t("ავტომობილები, რომლებსაც ადევნებთ თვალს.", "Cars you are keeping an eye on.", "Автомобили, за которыми вы следите.", "Մեքենաներ, որոնց հետևում եք։")} />
            <div className="container auction-narrow auction-wide auction-my">
                <Link to="/auction/my" className="auction-back">← {t("ჩემი აუქციონები", "My auctions", "Мои аукционы", "Իմ աճուրդները")}</Link>

                {!watch.authed ? (
                    <EmptyBlock title={t("გაიარეთ ავტორიზაცია", "Sign in", "Войдите", "Մուտք գործեք")} message={t("რჩეულების სანახავად შედით სისტემაში.", "Sign in to see your favorites.", "Войдите, чтобы увидеть избранное.", "Մուտք գործեք՝ ձեր ընտրանին տեսնելու համար։")}
                        action={<Link to="/auction/login" className="cx-btn cx-btn-primary">{t("შესვლა", "Sign in", "Вход", "Մուտք")}</Link>} />
                ) : rows.length === 0 ? (
                    <EmptyBlock title={t("რჩეულები ცარიელია", "No favorites yet", "Избранное пусто", "Ընտրանին դատարկ է")} message={t("აუქციონის ან ლოტის გვერდზე დააჭირეთ ⭐-ს, რომ მანქანა აქ დაემატოს.", "Tap the ⭐ on an auction or lot page to add a car here.", "Нажмите ⭐ на странице аукциона или лота, чтобы добавить авто сюда.", "Սեղմեք ⭐-ը աճուրդի կամ լոտի էջում՝ մեքենան այստեղ ավելացնելու համար։")}
                        action={<Link to="/auctions" className="cx-btn cx-btn-primary">{t("აუქციონები", "Auctions", "Аукционы", "Աճուրդներ")}</Link>} />
                ) : (
                    <section className="cx-card auction-my-section">
                        <h3><StarFill className="auction-sec-ico" /> {t("შენახული", "Saved", "Сохранённые", "Պահպանված")} ({rows.length})</h3>
                        <div className="auction-my-list">
                            {rows.map((w) => (
                                <div key={w.car_id} className="auction-my-row auction-watch-row">
                                    <div className="auction-my-thumb" style={thumbStyle(w.images)} />
                                    <Link to={`/car/${w.car_id}`} className="auction-my-main auction-watch-link">
                                        <strong>{carTitle(w)}</strong>
                                        <span className="auction-muted">
                                            {[w.year, w.millage ? formatMileage(w.millage) : null, w.fuel, w.transmission].filter(Boolean).join(" · ")}
                                        </span>
                                    </Link>
                                    <div className="auction-my-row-right">
                                        <span className="auction-won-price">{formatPrice(w.price, w.currency || "GEL")}</span>
                                        <button className="cx-btn cx-btn-ghost auction-watch-remove" onClick={() => watch.toggle(w.car_id)} title={t("მოხსნა", "Remove", "Убрать", "Հեռացնել")}>
                                            <StarFill /> {t("მოხსნა", "Remove", "Убрать", "Հեռացնել")}
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>
                )}
            </div>
        </>
    );
};

export default AuctionWatchlist;
